module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_ES-40a7917978ef1c57df9447e71619ff1a.svg";